import { render, staticRenderFns } from "./PagesSelector.vue?vue&type=template&id=cd3cc812"
import script from "./PagesSelector.vue?vue&type=script&lang=js"
export * from "./PagesSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cd3cc812')) {
      api.createRecord('cd3cc812', component.options)
    } else {
      api.reload('cd3cc812', component.options)
    }
    module.hot.accept("./PagesSelector.vue?vue&type=template&id=cd3cc812", function () {
      api.rerender('cd3cc812', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dash/overlay/PagesSelector.vue"
export default component.exports